exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\r\n  display: inline-block;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n}\r\n\r\n.mat-dialog-container{\r\n  padding:15px !important;\r\n}\r\n\r\n.removeScroll {\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/beneficiary-history/beneficiary-history.component.css
// module id = ../../../../../src/app/beneficiary-history/beneficiary-history.component.css
// module chunks = 0